import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import NavigationContent from "../navigation/NavigationContent";
import { AUTH_BASE_URL, STATIC_SERVER_URL } from "../../../config/config";
import SearchField from "../SearchField/SearchField";
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { authorizedState, loginModalState, registerModalState } from "atoms/atoms";
import { logout } from "services/logout";

import "./hamburger.scss";

const Hamburger = () => {
  const [isToggleOn, setIsToggleOn] = useState(false);
  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(0);
  const [height, setHeight] = useState(0);
  const setRegisterModalIsVisible = useSetRecoilState(registerModalState);
  const setLoginModalState = useSetRecoilState(loginModalState);
  const [authorized, setAuthorized] = useRecoilState(authorizedState);
  const navigate = useNavigate();
  const [firstName, setUserFirstName] = useState("");

  const handleClick = useCallback((e) => {
    e.preventDefault();
    setIsToggleOn((prev) => !prev);
    window.scrollTo(0, 0);
  }, []);

  const handleNavigationChange = useCallback(() => {
    setIsToggleOn(false);
  }, []);

  useEffect(() => {
    const el = document.getElementById("hamburger-navigation");
    if (el) {
      setTop(el.offsetTop);
      setHeight(el.offsetHeight);
    }

    fetch(`${AUTH_BASE_URL}/login/state`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then(async (res) => {
        if (res.status === 401) {
          setAuthorized(false);
          sessionStorage.removeItem("token");
          return;
        }

        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }

        const json = await res.json();
        setUserFirstName(json.first_name);
        setAuthorized(true);
      })
      .catch((err) => {
        console.error("Login state fetch error:", err);
        setAuthorized(false);
      });
  }, [authorized, setAuthorized]);

  useEffect(() => {
    if (isToggleOn) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isToggleOn]);

  useEffect(() => {
    if (scroll > top) {
      document.body.style.paddingTop = `${height}px`;
    } else {
      document.body.style.paddingTop = "0";
    }

    return () => {
      document.body.style.paddingTop = "0";
    };
  }, [scroll, top, height]);

  const handleRegisterClick = useCallback(() => {
    setRegisterModalIsVisible({ isVisible: true, redirectAfterLogin: null });
    setIsToggleOn(false);
  }, []);

  const handleLoginClick = useCallback(() => {
    console.log("CALLED");
    setLoginModalState({ isVisible: true, redirectAfterLogin: null });
    setIsToggleOn(false);
  }, []);

  const handleProfileClick = useCallback(() => {
    navigate("/profil");
  }, []);

  const handleLougoutClick = useCallback(() => {
    setIsToggleOn(false);
    const logoutResponse = logout();
    if (logoutResponse) {
      setAuthorized(false);
      navigate("/nyitolap");
    }
  }, []);

  return (
    <nav id="hamburger-navigation" className={scroll > top ? "fixed-nav" : ""}>
      <div className="hamburger-top">
        <div className="honvedfc-logo">
          <Link to="/nyitolap">
            <img
              src={`${STATIC_SERVER_URL}/web/images/crests/khfc.png`}
              alt="kezdőlap"
              title="kezdőlap"
            />
          </Link>
          <div className="title">
            <h1>Honvéd Shop</h1>
          </div>
        </div>
        <button
          type="button"
          className={`menu-toggle ${isToggleOn ? "active" : ""}`}
          onClick={handleClick}
        >
          Menü
        </button>
        <div className={`menu-sub ${isToggleOn ? "show" : "hidden"}`}>
          <div className="hamburger-navigation">
            <NavigationContent onNavigationClicked={handleNavigationChange} />
            <div id="account" className="mobile-account-container">
              {!authorized && (
                <>
                  <h4>Legyél tag!</h4>
                  <button
                    type="button"
                    className="btn btn-primary small"
                    onClick={handleRegisterClick}
                  >
                    Regisztráció
                  </button>
                  <button type="button" className="btn btn-black small" onClick={handleLoginClick}>
                    Bejelentkezés
                  </button>
                </>
              )}

              {authorized && (
                <>
                  <h4>Hello, {firstName}!</h4>
                  <button
                    type="button"
                    className="btn btn-primary small"
                    onClick={handleProfileClick}
                  >
                    Profil
                  </button>
                  <button
                    type="button"
                    className="btn btn-black small"
                    onClick={handleLougoutClick}
                  >
                    Kijelentkezés
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="search-bar show-mobile container">
        <SearchField />
      </div>
    </nav>
  );
};

export default Hamburger;
